import React from "react";

const username = (value) => {
  if (value.length < 3 || value.length > 20) {
    return <div role="alert">Must be between 3-20 characters</div>;
  }
};

export default username;
